import { render, staticRenderFns } from "./EnrollConfig.vue?vue&type=template&id=1889980b&scoped=true"
import script from "./EnrollConfig.vue?vue&type=script&lang=js"
export * from "./EnrollConfig.vue?vue&type=script&lang=js"
import style0 from "./EnrollConfig.vue?vue&type=style&index=0&id=1889980b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1889980b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1889980b')) {
      api.createRecord('1889980b', component.options)
    } else {
      api.reload('1889980b', component.options)
    }
    module.hot.accept("./EnrollConfig.vue?vue&type=template&id=1889980b&scoped=true", function () {
      api.rerender('1889980b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/enroll/EnrollConfig.vue"
export default component.exports